import { LineWeight, LineWeightOutlined } from '@mui/icons-material'
import { colors } from '@mui/material'
import React from 'react'
import {ReactComponent as VizIcon} from '../../Icons/vizIcon.svg';
import GenAiButtonSection from './GenAiButtonSection';
import GenAIContent from './GenAIContent';

export default function GenAIBox() {
    const containerStyle={
        height:'400px',
        border: '1px solid #E0E2E6',
        borderRadius: '12px',
        background:'#FFFFFF',
        boxShadow: '0px 4px 16px 0px #1018280F',
        marginTop:'8px'
    }
    const headingStyle={
       fontSize:'14px',
       lineHeight:'22px',
       fontWeight:'300',
       color:'#5C6676'
    }

  return (
    <>
    <div style={headingStyle}><VizIcon/>&nbsp;GenAI Response</div>
    <div style={containerStyle}>
    {/* <div style={{height:'320px', overflow:'auto'}}> */}
    <div style={{height:'320px', overflow:'auto'}}>
      <GenAIContent/>
    </div>
    <GenAiButtonSection/>
    </div>
    </>
  )
}
